const MODULE_NAME = 'search-ads-keyword';

const permissions = 'TOP_SEARCH_ADS_KEYWORDS_UI_TEST';

export { MODULE_NAME, permissions };
